<div class="study-viewer">
  <section class="viewer-header align-items-center">
    <a class="btn d-flex py-3" matRipple [matTooltip]="'Back'" (click)="closeViewer.emit(true)">
      <mat-icon>arrow_back</mat-icon>
    </a>
    <div class="has-border">
      <h1>Back to {{ view == 'meeting' ? 'Meeting' : 'Message' }}</h1>
    </div>

    <div class="histo-logo">
      <!-- <img src="./assets/images/logo/histo-app-logo.svg" alt=""> -->
    </div>
  </section>

  <section class="viewer-wrapper" *ngIf="viewerSrc">
    <iframe [src]="viewerSrc | sanitizeSrc" frameborder="0"></iframe>
  </section>
</div>
